import { format, isSameDay, isSameMonth, isSameYear, formatDistanceToNow, parseISO } from 'date-fns';

const DateUtility = {
  formatDate(date, formatString) {
    // If date is a string in ISO format (YYYY-MM-DD), parse it properly to prevent timezone issues
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      // For ISO date strings, use parseISO and ensure timezone doesn't shift the date
      return format(parseISO(date), formatString);
    }
    return format(date, formatString);
  },
  isDateSame(date1, date2, period) {
    switch (period) {
      case 'day':
        return isSameDay(date1, date2);
      case 'month':
        return isSameMonth(date1, date2);
      case 'year':
        return isSameYear(date1, date2);
      default:
        return false;
    }
  },
  fromNow(date) {
    return formatDistanceToNow(date, { addSuffix: false });
  },
};

export default DateUtility;
